/* eslint-disable react-hooks/exhaustive-deps */
import { useTranslation } from 'react-i18next'
import { useMemo, useContext } from 'react'
import moment from 'moment'
import { UserContext } from 'stores/UserStore'

const useFilters = () => {
  const { t } = useTranslation()
  const { currentUser } = useContext(UserContext)
  
  const filters = useMemo(() => {
    const result = [
      {
        accessor: 'sot',
        label: t('inspectionReport.sot')
      },
      {
        accessor: 'sot_item',
        label: t('inspectionReport.item')
      },
      {
        accessor: 'report_id',
        label: t('inspectionReport.id')
      },
      {
        accessor: 'report_version',
        label: t('inspectionReport.version')
      },
      {
        accessor: 'inspection_date',
        label: t('inspectionReport.inspectionDate'),
        formatter: value => value ? moment.utc(value).format('DD/MM/YYYY') : ''
      },
      {
        accessor: 'report_date',
        label: t('inspectionReport.creationDate'),
        formatter: value => value ? moment.utc(value).format('DD/MM/YYYY') : ''
      },
      {
        accessor: 'process_status',
        label: t('inspectionReport.processStatus'),
        formatter: value => t(`inspectionReport.${value}`)
      }
    ]
    if (currentUser && currentUser.roles.INSPECTION_REPORT && currentUser.roles.INSPECTION_REPORT.WORKFLOW_MANAGER) {
      result.push({
        accessor: 'workflow_status',
        label: t('inspectionReport.current-step'),
        formatter: value => t(`inspectionReport.${value}`)
      })
      result.push({
        accessor: 'next_workflow_status',
        label: t('inspectionReport.next-step'),
        formatter: value => t(`inspectionReport.${value}`)
      })
    }

      return result

  }, [t])

  return filters
}

export default useFilters